/*
 * fn: getSidebarsCookie
 *
 * Gets which sidebars are locked from their cookies
 *
 */
import { type SidebarsLockedType } from '@/defs/view'

import { getCookies } from './getCookies'

export const getSidebarsCookie = (): SidebarsLockedType => {
  const cookies = getCookies()

  return {
    clipboard: cookies.get('clipboard') === 'locked',
    filters: cookies.get('filters') === 'locked',
    gallery: cookies.get('gallery') === 'locked',
  }
}
